// extracted by mini-css-extract-plugin
module.exports = {"isValid":"YmyPwaq4mOHPc9p5Kw9rO"};